import {CreateAxiosInstance, BuildUrl} from './apiHelpers';
import axios from "axios";
import pica from 'pica';

// Downloads an image from a url and converts it to base64 string
// If the url is empty or has the ?nc parameter, it returns undefined
export async function convertImageUrlToBase64(
    imageUrl: string
): Promise<string | undefined> {
    if (!imageUrl) return;

    // Gets the image from the url
    const imgResponse = await fetch(imageUrl);
    const blob = await imgResponse.blob();

    // Converts the image to base64
    const base64 = await convertBlobToBase64(blob);
    return base64;
}

// Downloads a blob and converts it to base64 string
export async function convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const base64data = reader.result as string;
            resolve(base64data);
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(blob);
    });
}

// V2 --------------

export async function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export async function removeBackground(imageDataUrl: string, crop: boolean = true, width: number=0, height: number=0): Promise<string> {
    // Quita el prefijo "data:image/png;base64," si existe
    let base64 = imageDataUrl;
    const prefix = "base64,";
    const idx = base64.indexOf(prefix);
    if (idx >= 0) base64 = base64.substring(idx + prefix.length);

    console.log("removeBackground", imageDataUrl);

    const url = BuildUrl('images/remove-background');
    const api = CreateAxiosInstance();
    const resp = await api.post(url, {
        imageDataUrl: base64, crop: crop
    });

    // Espera que el backend regrese { result_b64 }
    const resultB64 = resp.data.result_b64;


    return "data:image/png;base64," + resultB64;
}

export async function uploadImages({main, thumb, original}: {
    main: string,
    thumb: string,
    original: File | null
}) {
    const form = new FormData();
    form.append('main', await dataUrlToBlob(main));
    form.append('thumb', await dataUrlToBlob(thumb));
    if (original) form.append('original', original);

    const resp = await fetch('/api/images/upload', {
        method: 'POST',
        body: form,
    });
    if (!resp.ok) throw new Error('Upload failed');
}

async function dataUrlToBlob(dataUrl: string): Promise<Blob> {
    const res = await fetch(dataUrl);
    return await res.blob();
}

export async function resizeImage(dataUrl: string, width: number, height: number): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new window.Image();
        img.onload = async () => {
            // If the image is not squared, create a square canvas (width x height), center the image, and fill the rest with transparent
            if (width === height && img.width !== img.height) {
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d')!;
                // Transparent background by default
                ctx.clearRect(0, 0, width, height);
                // Fill with green background instead of transparent
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, width, height);
                // Calculate scale to fit image in square
                const scale = Math.min(width / img.width, height / img.height);
                const newW = img.width * scale;
                const newH = img.height * scale;
                ctx.drawImage(
                    img,
                    (width - newW) / 2,
                    (height - newH) / 2,
                    newW,
                    newH
                );
                resolve(canvas.toDataURL('image/png'));
                return;
            }

            // If the image is smaller or equal to the required size, do not resize
            if (img.width <= width && img.height <= height) {
                resolve(dataUrl);
                return;
            }
            // Calcula escala para que la imagen quepa entera en el cuadrado (width x height)
            const scale = Math.min(width / img.width, height / img.height);
            const newW = img.width * scale;
            const newH = img.height * scale;

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d')!;

            // Fondo transparente
            ctx.clearRect(0, 0, width, height);

            // Centra la imagen redimensionada
            ctx.drawImage(
                img,
                (width - newW) / 2,
                (height - newH) / 2,
                newW,
                newH
            );

            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = dataUrl;
    });
}